module.exports = __webpack_public_path__ + "static/media/logo.4293b03f.svg";